import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Ticket details", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Standard = _resolveComponent("Standard")!
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.ticket.action=='ticket_standard')
      ? (_openBlock(), _createBlock(_component_Standard, {
          key: 0,
          ticket: _ctx.ticket,
          onReload: _ctx.reloadTicketDetails
        }, null, 8, ["ticket", "onReload"]))
      : (_ctx.ticket.action=='ticket_alert')
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 1,
            ticket: _ctx.ticket,
            onReload: _ctx.reloadTicketDetails
          }, null, 8, ["ticket", "onReload"]))
        : _createCommentVNode("", true)
  ]))
}